<!-- 登录 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="550px"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        status-icon
        :rules="rules"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item
          label-width="0"
          prop="usernameOrEmailAddress"
        >
          <el-input
            v-model="ruleForm.usernameOrEmailAddress"
            class="ipth60"
            placeholder="请您输入用户名"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label-width="0"
          prop="password"
        >
          <el-input
            v-model="ruleForm.password"
            class="ipth60"
            placeholder="请您输入密码"
            type="password"
            autocomplete="off"
          />
        </el-form-item>

        <el-form-item class="flex">
          <el-row
            type="flex"
            class="row-bg"
            justify="space-between"
          >
            <el-col :span="11">
              <el-button
                class="w100"
                type="primary"
                @click="submitForm('ruleForm')"
              >
                提交
              </el-button>
            </el-col>
            <el-col :span="11">
              <el-button
                class="w100"
                @click="resetForm('ruleForm')"
              >
                取消
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">保  存</el-button>
      </span>-->
    </el-dialog>
    <SelectRole v-model="selectRoleShow" />
  </div>
</template>

<script>
import pathReq from '../../api/pathlist'
import SelectRole from './SelectRole'

export default {
  components: { SelectRole },
  data() {
    var checkUsernameOrEmailAddress = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }

    return {
      selectRoleShow: false,
      dialogVisible: false,
      ruleForm: {
        tenancyName: '',
        usernameOrEmailAddress: '',
        password: '',
        rememberMe: true

      },
      rules: {
        usernameOrEmailAddress: [{
          validator: checkUsernameOrEmailAddress,
          trigger: 'blur'
        }],
        password: [{
          validator: validatePass,
          trigger: 'blur'
        }]
      }
    }
  },
  created() {
    this.$bus.off('show/login')
    this.$bus.on('show/login', () => {
      this.dialogVisible = true
    })
  },

  methods: {
    handleClose() {
      this.dialogVisible = false
    },

    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const path = '/api/TokenAuth/Authenticate'
          pathReq.postForm(path, that.ruleForm).then((res) => {
            if (res.status === 200) {
              if (res.data.success) {
                const accessToken = res.data.result.accessToken
                const encryptedAccessToken = res.data.result.encryptedAccessToken
                const userId = res.data.result.userId
                const hasIdentityData = res.data.result.hasIdentityData

                localStorage.setItem('isLogin', true)
                localStorage.setItem('accessToken', accessToken)
                localStorage.setItem('encryptedAccessToken', encryptedAccessToken)
                localStorage.setItem('userId', userId)
                localStorage.setItem('userName', that.ruleForm.usernameOrEmailAddress)
                localStorage.setItem('userPsd', that.ruleForm.password)

                if (hasIdentityData) {
                  // that.$bus.emit('show/role')
                  this.selectRoleShow = true
                } else {
                  this.$router.push('/gr/profile')
                }
              }
            }
          })
          this.dialogVisible = false
        } else {
          return false
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    }
  }

}
</script>

<style scoped>
.w40 {
  width: 40%;
}

.w100 {
  width: 100%;
}

/* .ipth60 {
  height: 60px;
} */

.el-input__inner {
  height: 100%;
}
</style>
